import React from "react";
import Spinner from 'react-bootstrap/Spinner';

const CommonLoader = (props) => {
  const { boxClass ,loaderClass} = props;
  return (
    <div className={boxClass}>
      <Spinner color="secondary" size="" className={loaderClass}>
      </Spinner>
    </div>
  );
};

export default CommonLoader;